export const SEXTANTE_LOGO_ROUTE: string = "assets/sextante_logo.png";
export const SEXTANTE_BRAND_ROUTE: string = "assets/sextante_brand.png";
export const SEXTANTE_DEFAULT_TITLE: string = "DATA AG";

//

// Marca Nitrofert: el producto se llama Nitria (antes SOIL).
export const NITROFERT_LOGO_ROUTE: string = "assets/nitria_logo.png";
export const NITROFERT_BRAND_ROUTE: string = "assets/nitria_brand.png";
export const NITROFERT_DEFAULT_TITLE: string = "Nitria";
/** Login del portal de Nitria: a donde va Plataforma Nitrofert sin sesión
 *  válida (SSO, decidido 2026-09-30). Depende del ambiente (2026-10-05): en
 *  dev y test, el portal de desarrollo; en prod, el de producción. */
export const TESTING_NITROFERT_PORTAL_LOGIN_URL: string =
  "https://portal-apps-dev.nitrofert.com.co/auth/login";
export const RELEASE_NITROFERT_PORTAL_LOGIN_URL: string =
  "https://apps.nitria.com.co/";

//

/** `SYNC_KEY_*`: clave única de cada listado en memoria (`ServiceGetListBase.syncKey`, deduplicación
 *  de `sync()`). No son rutas: la SPA solo habla gRPC-Web. */
export const SYNC_KEY_TERCEROS_CLIENTES   = "terceros/clientes";
export const SYNC_KEY_TERCEROS_PROMOTORES = "terceros/promotores";
export const SYNC_KEY_TERCEROS_FINCAS     = "terceros/fincas";

//

export const GOOGLE_MAPS_API_KEY: string =
  "AIzaSyBmaNcwYynVMXHhKQWQUwXzQR6IY4OO_CA";

//

export const SYNC_KEY_CATALOGOS_PLAGAS_ENFERMEDADES = "catalogos/monitoreo-plagas-enfermedades";
export const SYNC_KEY_CATALOGOS_ESTADOS_FENOLOGICOS = "catalogos/monitoreo-estados-fenologicos";

/** Prefijo de `uriOrtomosaico` servido desde este contenedor: no requiere SAS de
 *  lectura (a diferencia del contenedor privado de `storage/tiles/sas-read`) -son
 *  ortomosaicos viejos guardados en OTRA cuenta de storage; pegarle el SAS de
 *  esta cuenta no autentica, ni por error-. Mismo criterio que Cliente. */
export const ORTOMOSAICO_PUBLIC_URI_PREFIX = "https://ernestogverp.blob.core.windows.net/";

//

export const SYNC_KEY_COSTOS_AGRICULTURA   = "costos/agricultura";
export const SYNC_KEY_COSTOS_GANADERIA     = "costos/ganaderia";
export const SYNC_KEY_COSTOS_ASPERSION     = "costos/aspersion";
export const SYNC_KEY_COSTOS_EQUIPOS       = "costos/equipos";
export const SYNC_KEY_COSTOS_FOTOGRAMETRIA = "costos/fotogrametria";

//

export const SYNC_KEY_SEGURIDAD_USUARIOS_PLATAFORMA = "seguridad/usuarios-plataforma";
export const SYNC_KEY_SEGURIDAD_USUARIOS_APP        = "seguridad/usuarios-app";

//

export const SYNC_KEY_HARDWARE_GPS_TRACKERS = "hardware/gps-trackers";

//

export const SYNC_KEY_MARKETING_CAMPANAS = "marketing/campanas";

//

export const SYNC_KEY_PROYECTOS_SNAPSHOTS       = "proyectos/snapshots";
export const SYNC_KEY_PROYECTOS_TECNICOS        = "proyectos/tecnicos";
export const SYNC_KEY_PROYECTOS_CULTIVOS        = "proyectos/cultivos";
export const SYNC_KEY_PROYECTOS_CATALOGO        = "proyectos/catalogo";
export const SYNC_KEY_PROYECTOS_PROYECTOS       = "proyectos/proyectos";
export const SYNC_KEY_PROYECTOS_FASES           = "proyectos/fases";
export const SYNC_KEY_PROYECTOS_NUCLEOS         = "proyectos/nucleos";
export const SYNC_KEY_PROYECTOS_COSECHAS        = "proyectos/cosechas";
export const SYNC_KEY_PROYECTOS_MACRO_PROYECTOS = "proyectos/macro-proyectos";
